import React, { useContext, useEffect, useRef, useState } from 'react';
import TaskAltIcon from '@mui/icons-material/TaskAlt';
import ComponentContainer from './componentContainer';
import { Autocomplete, Box, Button, Divider, FormControl, Grid, InputAdornment, List, ListItem, ListItemText, Menu, MenuItem, Modal, Paper, Radio, Select, Tab, Tabs, TextField, Typography } from '@mui/material';
import Util from '../util/util';
import globalContext from './globalContext';
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import DateFnsUtils from "@date-io/date-fns";
import { hr } from "date-fns/locale";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import { styled } from "@mui/system";
import SearchIcon from "@mui/icons-material/Search";
import CheckIcon from '@mui/icons-material/Check';
import api from '../util/api';
import AlertDialog from './alertdialog';
import ErrorIcon from '@mui/icons-material/Error';
import AddEditDelForm from './addEditDelForm';
import ZadatakForm from './zadatakForm';
import AssignmentTurnedInIcon from '@mui/icons-material/AssignmentTurnedIn';
import EvidencijaForm from './evidencijaForm';
import dateFormat, { masks } from "dateformat";
import HighlightOffIcon from '@mui/icons-material/HighlightOff';

const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    bgcolor: 'white',
    border: '2px solid #000',
    p: 6,
    padding:'15px',
    maxHeight: '95%',
    maxWidth: '95%'
};

const monthNames = ["siječanj", "veljača", "ožujak", "travanj", "svibanj", "lipanj",
  "srpanj", "kolovoz", "rujan", "listopad", "studeni", "prosinac"
];

const StyledTextField = styled(TextField)`
    .MuiOutlinedInput-input {
        cursor: pointer;
    }
    .MuiOutlinedInput-root {
        :hover fieldset {
            cursor: pointer;
        }
    }
`;

const CustomPaper = (props) => {
    return <Paper elevation={24} variant="outlined" style={{borderStyle:'solid', borderWidth:'2px'}} {...props} />;
};

export default function Zadaci(props) {

    const useConstructor = Util.useConstructor();
    const global = useContext(globalContext);

    var periodOptions = [
        { KorisnikID: global.user.korisnikID, PeriodID: 1, Naziv: "1 dan", Vrijednost: 1, TipJediniceID: 1 },
        { KorisnikID: global.user.korisnikID, PeriodID: 2, Naziv: "1 tjedan", Vrijednost: 1, TipJediniceID: 2 },
        { KorisnikID: global.user.korisnikID, PeriodID: 3, Naziv: "2 tjedna", Vrijednost: 2, TipJediniceID: 2 },
        { KorisnikID: global.user.korisnikID, PeriodID: 4, Naziv: "1 mjesec", Vrijednost: 1, TipJediniceID: 3 },
        { KorisnikID: global.user.korisnikID, PeriodID: 5, Naziv: "1 godina", Vrijednost: 1, TipJediniceID: 4 },
        { KorisnikID: global.user.korisnikID, PeriodID: 6, Naziv: "Svi zadaci oduvijek", Vrijednost: 0, TipJediniceID: 1 },
        { KorisnikID: global.user.korisnikID, PeriodID: 7, Naziv: "Kalendarski odabir", Vrijednost: 0, TipJediniceID: 1 },
    ];

    const calendarPeriodOptions = [
        { Naziv: "Za godinu", Vrijednost: 2},
        { Naziv: "Za mjesec", Vrijednost: 3},
        { Naziv: "Za datum", Vrijednost: 4},
        { Naziv: "Za razdoblje", Vrijednost: 5}
    ];
    
    const klijentiPredmeti = props.klijentiPredmeti || {
        Klijenti : [],
        Predmeti: [],
        KlijentiLastUpdate : null,
        PredmetiLastUpdate : null
    };
    const loadKlijentiAndPredmeti = props.loadKlijentiAndPredmeti;

    const [datum, setDatum] = useState(new Date());
    const [anchorEl, setAnchorEl] = useState(null);
    const periodMenuOpened = Boolean(anchorEl);
    const [period, setPeriod] = useState(periodOptions[0]);
    const [datumOd, setDatumOd] = useState(datum);
    const [periodHistory, setPeriodHistory] = useState(periodOptions[0]);
    const [datumOd1, setDatumOd1] = useState(new Date());
    const [datumDo, setDatumDo] = useState(new Date());
    const [mjesec, setMjesec] = useState(new Date());
    const [godina, setGodina] = useState(new Date());
    const [calendarPeriodOption, setCalendarPeriodOption] = useState(calendarPeriodOptions.at(3));
    const [prioriteti, setPrioriteti] = useState([]);
    const [prioritet, setPrioritet] = useState(null);
    const [statusi, setStatusi] = useState([]);
    const [status, setStatus] = useState(null);
    const [loading, setLoading] = useState(true);
    const [errorMessage, setErrorMessage] = useState("");
    const [klijent, setKlijent] = useState(null);
    const [predmet, setPredmet] = useState(null);
    const [zadaci, setZadaci] = useState([]);
    const [uloge, setUloge] = useState([]);
    const [currentZadatak, setCurrentZadatak] = useState(null);
    const [uloga, setUloga] = useState(0);
    const [formOpened, setFormOpened] = useState(false);
    const [zadatakForEdit, setZadatakForEdit] = useState(null);
    const [ponistiAlert, setPonistiAlert] = useState(false);
    const [evidencijaOpened, setEvidencijaOpened] = useState(false);
    const [zadatakEvidencijaInfo, setZadatakEvidencijaInfo] = useState(null);
    const [periodLabel, setPeriodLabel] = useState("");
    const [deleteAlert, setDeleteAlert] = useState(false);
    const [logoutAlert, setLogoutAlert] = useState(false);

    const lastCurrent = useRef();

    useConstructor(() => {

        if (klijentiPredmeti.KlijentiLastUpdate != "" && klijentiPredmeti.KlijentiLastUpdate != null && klijentiPredmeti.PredmetiLastUpdate != "" && klijentiPredmeti.PredmetiLastUpdate != null) {
            let resource = {
                FirmaID : global.user.firmaID,
                KlijentiLastUpdate : klijentiPredmeti.KlijentiLastUpdate,
                PredmetiLastUpdate : klijentiPredmeti.PredmetiLastUpdate,
                KorisnikID : global.user.korisnikID
            }
            api.post("firma/checkeverything", resource, checkEverythingSuccess, fail);
        }

    });

    function checkEverythingSuccess(data) {
        if(data && (data.UserAccountValid == false || data.LogoutRequired)){
            setLoading(false);
            setLogoutAlert(true);
            return;          
        }

        if (data.CheckIfKlijentiOrPredmetiUnchangedResource == false) {
            loadKlijentiAndPredmeti(global.user.firmaID, loadInfo, data.KlijentiChanged, data.PredmetiChanged);
        } else {
            loadInfo();
        }
    }

    function startLogout(){
        setLogoutAlert(false);
        Util.logout();
        window.location = "/#/login";
    }

    function loadInfo() {
        api.get("zadatak/getinfo/" + global.user.korisnikID, loadInfoSuccess, fail);
    }

    function loadInfoSuccess(data) {
        let sviPrioriteti = [{ TipZadatakPrioritetID: 0, Naziv: "Svi" }, ...data.Prioriteti];
        setPrioriteti(sviPrioriteti);
        let sviStatusi = [{ TipZadatakStatusID: 0, Naziv: "Svi" }, { TipZadatakStatusID: -1, Naziv: "Aktivni" }, ...data.Statusi];
        setStatusi(sviStatusi);
        setPreferredRange(data.Filter.Period);
        setKlijent([{KlijentID: 0, Naziv:"Svi"}, ...klijentiPredmeti.Klijenti].find(k => k.KlijentID == (data.Filter.KlijentID || 0)));
        setPredmet([{PredmetID: 0, Naziv:"Svi"}, ...klijentiPredmeti.Predmeti].find(k => k.PredmetID == (data.Filter.PredmetID || 0)));
        setPrioritet(sviPrioriteti.find(p => p.TipZadatakPrioritetID == (data.Filter.TipZadatakPrioritetID || 0)));
        setStatus(sviStatusi.find(s => s.TipZadatakStatusID == (data.Filter.TipZadatakStatusID != null ? data.Filter.TipZadatakStatusID : 0)));
        let newUloge = [
            { Vrijednost: 0, Naziv: "Zadaci koje izvršava " }
        ];
        if (data.Zadavatelj) {
            newUloge.push({ Vrijednost: 1, Naziv: "Zadaci koje je zadao/la " });
        }
        setUloge(newUloge);
        data.Filter.Period = {
            ...data.Filter.Period,
            Datum: datum,
            PeriodID: findPeriodID(data.Filter.Period)};
        filter({
            ...data.Filter,
            KorisnikID: global.drugiZaposlenik ? global.drugiZaposlenik.KorisnikID : global.user.korisnikID
        });
    }

    function findPeriodID(range) {
        if (range.TipPregleda == 1) {
            if (range.Vrijednost || range.TipJediniceID) {
                if (range.Vrijednost == 1 && range.TipJediniceID == 1) {
                   return 1;
                } else if (range.Vrijednost == 1 && range.TipJediniceID == 2) {
                    return 2;
                } else if (range.Vrijednost == 2 && range.TipJediniceID == 2) {
                    return 3;
                } else if (range.Vrijednost == 1 && range.TipJediniceID == 3) {
                    return 4;
                } else if (range.Vrijednost == 1 && range.TipJediniceID == 4) {
                    return 5;
                } else if (range.Vrijednost == 0 && range.TipJediniceID == 1) {
                    return 6;
                }
            }
        } else if (range.TipPregleda == 2) {
            return 7;
        }
    }

    function setPreferredRange(range) {
        if (range.TipPregleda == 1) {
            if (range.Vrijednost || range.TipJediniceID) {
                if (range.Vrijednost == 1 && range.TipJediniceID == 1) {
                    setPeriod(periodOptions[0]);
                    setPeriodHistory(periodOptions[0]);
                } else if (range.Vrijednost == 1 && range.TipJediniceID == 2) {
                    setPeriod(periodOptions[1]);
                    setPeriodHistory(periodOptions[1]);
                } else if (range.Vrijednost == 2 && range.TipJediniceID == 2) {
                    setPeriod(periodOptions[2]);
                    setPeriodHistory(periodOptions[2]);
                } else if (range.Vrijednost == 1 && range.TipJediniceID == 3) {
                    setPeriod(periodOptions[3]);
                    setPeriodHistory(periodOptions[3]);
                } else if (range.Vrijednost == 1 && range.TipJediniceID == 4) {
                    setPeriod(periodOptions[4]);
                    setPeriodHistory(periodOptions[4]);
                } else if (range.Vrijednost == 0 && range.TipJediniceID == 1) {
                    setPeriod(periodOptions[5]);
                    setPeriodHistory(periodOptions[5]);
                } else {
                    let newPeriod = {
                        KorisnikID: range.KorisnikID,
                        PeriodID: range.PeriodID,
                        Naziv: range.Naziv,
                        Vrijednost: range.Vrijednost,
                        TipJediniceID: range.TipJediniceID,
                    };
                    setPeriod(newPeriod);
                    setPeriodHistory(range);
                }
            }
        } else if (range.TipPregleda == 2) {
            setPeriod(periodOptions[6]);
            setPeriodHistory(periodOptions[6]);
            setDatumOd1(range.DatumOd);
            setDatumDo(range.DatumDo);
            setMjesec(range.DatumOd);
            setGodina(range.DatumOd);
            setCalendarPeriodOption(range.TipPregledaKalendara ? calendarPeriodOptions.find(x=>x.Vrijednost == range.TipPregledaKalendara) : calendarPeriodOptions.find(x=>x.Vrijednost == 3));
        }
    }

    function fail(data) {
        setErrorMessage(data ? (data.Message || data.toString()) : "");
        setLoading(false);
    }

    function filter(filterResource) {
        setLoading(true);
        var resourceDatumOd;
        switch (calendarPeriodOption.Vrijednost) {
            case 1:
                resourceDatumOd = datumOd1;
                break;
            case 2:
                resourceDatumOd = godina;
                break;
            case 3:
                resourceDatumOd = mjesec;
                break;
            case 4:
                resourceDatumOd = datumOd1;
                break;
            case 5:
                resourceDatumOd = datumOd1;
                break;
        }
        let resource = filterResource || {
            KorisnikID: global.drugiZaposlenik ? global.drugiZaposlenik.KorisnikID : global.user.korisnikID,
            TipZadatakStatusID: status.TipZadatakStatusID,
            TipZadatakPrioritetID: prioritet.TipZadatakPrioritetID,
            KlijentID: klijent.KlijentID,
            PredmetID: predmet.PredmetID,
            Period: {
                ...period,
                DatumOd: resourceDatumOd,
                DatumDo: datumDo,
                Datum: datum,
                TipPregleda: period.PeriodID == 7 ? 2 : 1,
                TipPregledaKalendara: calendarPeriodOption.Vrijednost
            }
        }
        var newPeriodLabel = "";
        if (resource.Period && resource.Period.PeriodID == 6) {
            newPeriodLabel = "";
        } else if (resource.Period && resource.Period.PeriodID != 7) {
            newPeriodLabel = "";
        } else {
            if (resource.Period.DatumOd) {
                let dteFrom = new Date(resource.Period.DatumOd);
                if(resource.Period.TipPregledaKalendara == 2){
                    newPeriodLabel = "Period: " + dteFrom.getFullYear() + ". godina";
                }    
                if(resource.Period.TipPregledaKalendara == 3){
                    newPeriodLabel = "Period: " + monthNames[dteFrom.getMonth()] + " " + dteFrom.getFullYear() + ". godine";
                }    
                if(resource.Period.TipPregledaKalendara == 4){
                    newPeriodLabel = "Datum: " + dteFrom.getDate() + ". "  + monthNames[dteFrom.getMonth()] + " " + dteFrom.getFullYear() + ". godine";
                }    
                if(resource.Period.TipPregledaKalendara == 5){
                    newPeriodLabel = "Period: " + "od " + dateFormat(resource.Period.DatumOd, "dd.mm.yyyy.") + " do " + dateFormat(resource.Period.DatumDo, "dd.mm.yyyy.");
                }    
            } else {
                newPeriodLabel = "Period: "
            }
        }
        setPeriodLabel(newPeriodLabel);
        api.post("zadatak/filter", resource, filterSuccess, fail);
    }

    function filterSuccess(data) {
        setZadaci(data.Zadaci);
        setCurrentZadatak(null);
        if (data.DatumOd != null) {
            setPeriodLabel("Period: " + data.DatumOd && datum ? ("od " + dateFormat(data.DatumOd, "dd.mm.yyyy.") + " do " + dateFormat(datum, "dd.mm.yyyy.")) : "");
        }
        if (uloga == 0) {
            if (lastCurrent.current != null && data.Zadaci.filter(z => z.KorisniciIDs.includes(parseInt(global.drugiZaposlenik ? global.drugiZaposlenik.KorisnikID : global.user.korisnikID))).find(z => z.ZadatakID == lastCurrent.current)) {
                setCurrentZadatak(data.Zadaci.find(z => z.ZadatakID == lastCurrent.current));
            } else if (data.Zadaci.filter(z => z.KorisniciIDs.includes(parseInt(global.drugiZaposlenik ? global.drugiZaposlenik.KorisnikID : global.user.korisnikID))).length > 0) {
                setCurrentZadatak(data.Zadaci.filter(z => z.KorisniciIDs.includes(parseInt(global.drugiZaposlenik ? global.drugiZaposlenik.KorisnikID : global.user.korisnikID)))[0]);
            }
        } else {
            if (lastCurrent.current != null && data.Zadaci.filter(z => z.ZadavateljKorisnikID == (global.drugiZaposlenik ? global.drugiZaposlenik.KorisnikID : global.user.korisnikID)).find(z => z.ZadatakID == lastCurrent.current)) {
                setCurrentZadatak(data.Zadaci.find(z => z.ZadatakID == lastCurrent.current));
            } else if (data.Zadaci.filter(z => z.ZadavateljKorisnikID == (global.drugiZaposlenik ? global.drugiZaposlenik.KorisnikID : global.user.korisnikID)).length > 0) {
                setCurrentZadatak(data.Zadaci.filter(z => z.ZadavateljKorisnikID == (global.drugiZaposlenik ? global.drugiZaposlenik.KorisnikID : global.user.korisnikID))[0]);
            }
        }
        setLoading(false);
    }

    function handleDatumChange(v) {
        setDatum(v);
        filter({
            KorisnikID: global.drugiZaposlenik ? global.drugiZaposlenik.KorisnikID : global.user.korisnikID,
            TipZadatakStatusID: status.TipZadatakStatusID,
            TipZadatakPrioritetID: prioritet.TipZadatakPrioritetID,
            KlijentID: klijent.KlijentID,
            PredmetID: predmet.PredmetID,
            Period: {
                ...period,
                DatumOd: datumOd,
                DatumDo: datumDo,
                TipPregleda: period.PeriodID == 7 ? 2 : 1,
                Datum: v,
                TipPregledaKalendara: calendarPeriodOption.Vrijednost
            }
        });
    }

    function handlePeriodClick(event) {
        setAnchorEl(event.currentTarget);
    }

    function handleDatumOdChange(v) {
        setDatumOd1(v);
    }

    function handleDatumDoChange(v) {
        setDatumDo(v);
    }

    function handlePrimijeniClick() {
        setPeriodHistory(period);
        var resourceDatumOd;
        switch (calendarPeriodOption.Vrijednost) {
            case 1:
                resourceDatumOd = datumOd1;
                break;
            case 2:
                resourceDatumOd = godina;
                break;
            case 3:
                resourceDatumOd = mjesec;
                break;
            case 4:
                resourceDatumOd = datumOd1;
                break;
            case 5:
                resourceDatumOd = datumOd1;
                break;
        }   
        filter({
            KorisnikID: global.drugiZaposlenik ? global.drugiZaposlenik.KorisnikID : global.user.korisnikID,
            TipZadatakStatusID: status.TipZadatakStatusID,
            TipZadatakPrioritetID: prioritet.TipZadatakPrioritetID,
            KlijentID: klijent.KlijentID,
            PredmetID: predmet.PredmetID,
            Period: {
                ...period,
                DatumOd: resourceDatumOd,
                DatumDo: datumDo,
                Datum: datum,
                TipPregleda: period.PeriodID == 7 ? 2 : 1,
                TipPregledaKalendara: calendarPeriodOption.Vrijednost
            }
        });
        setAnchorEl(null);
    }

    function handleKlijentChange(e,v) {
        setKlijent(v);
        setPredmet({PredmetID: 0, Naziv:"Svi"});
        filter({
            KorisnikID: global.drugiZaposlenik ? global.drugiZaposlenik.KorisnikID : global.user.korisnikID,
            TipZadatakStatusID: status.TipZadatakStatusID,
            TipZadatakPrioritetID: prioritet.TipZadatakPrioritetID,
            KlijentID: v.KlijentID,
            PredmetID: 0,
            Period: {
                ...period,
                DatumOd: datumOd,
                DatumDo: datumDo,
                Datum: datum,
                TipPregleda: period.PeriodID == 7 ? 2 : 1,
                TipPregledaKalendara: calendarPeriodOption.Vrijednost
            }
        });
    }

    function handlePredmetChange(e,v) {
        setPredmet(v);
        filter({
            KorisnikID: global.drugiZaposlenik ? global.drugiZaposlenik.KorisnikID : global.user.korisnikID,
            TipZadatakStatusID: status.TipZadatakStatusID,
            TipZadatakPrioritetID: prioritet.TipZadatakPrioritetID,
            KlijentID: klijent.KlijentID,
            PredmetID: v.PredmetID,
            Period: {
                ...period,
                DatumOd: datumOd,
                DatumDo: datumDo,
                Datum: datum,
                TipPregleda: period.PeriodID == 7 ? 2 : 1,
                TipPregledaKalendara: calendarPeriodOption.Vrijednost
            }
        });
    }

    function add() {
        setZadatakForEdit(null);
        setFormOpened(true);
    }

    function edit() {
        setZadatakForEdit(currentZadatak);
        setFormOpened(true);
    }

    function ponisti() {
        setLoading(true);
        api.get("zadatak/ponisti/" + currentZadatak.ZadatakID, ponistiSuccess, fail);
    }

    function ponistiSuccess() {
        setPonistiAlert(false);
        lastCurrent.current = currentZadatak.ZadatakID;
        filter(null);
    }

    function del() {
        setLoading(true);
        api.get("zadatak/obrisi/" + currentZadatak.ZadatakID, deleteSuccess, fail);
    }

    function deleteSuccess() {
        lastCurrent.current = currentZadatak.ZadatakID;
        setDeleteAlert(false);
        filter(null);
    }

    function evidencija() {
        setLoading(true);
        api.get("zadatak/getzadatakevidencijainfo/" + currentZadatak.ZadatakID, getEvidencijaInfoSuccess, fail);
    }

    function getEvidencijaInfoSuccess(data) {
        setZadatakEvidencijaInfo(data);
        setEvidencijaOpened(true);
        setLoading(false);
    }

    function saveSamoOtvoreniPredmeti(samoOtvoreniPredmeti) {
        api.get("korisnik/spremidefsamootvorenipredmeti/" + samoOtvoreniPredmeti);
    }

    function saveSamoAktivniKlijenti(samoAktivniKlijenti) {
        api.get("korisnik/spremidefsamoaktivniklijenti/" + samoAktivniKlijenti);
    }

    return (
        <ComponentContainer loading={loading}>
            <Grid container spacing={1}>
                <Grid item xs={12}>
                    <Typography variant="h4" gutterBottom component="div" style={{marginBottom:"20px", display:"flex", alignItems:"center"}}>
                        <TaskAltIcon fontSize="medium" style={{marginRight:"15px"}}></TaskAltIcon>
                        Zadaci
                    </Typography>
                </Grid>
                <Grid item xs={5} sm={5} md={2}>
                    <LocalizationProvider dateAdapter={AdapterDateFns} locale={hr} utils={DateFnsUtils} fullWidth>
                        <DatePicker label="Datum" value={datum} inputFormat="dd.MM.yyyy" onChange={handleDatumChange} renderInput={(params) => <TextField style={{ width: "99%" }} {...params} size="small" error={!datum || isNaN(new Date(datum))} />} />
                    </LocalizationProvider>
                </Grid>
                <Grid item xs={7} sm={7} md={4}>
                    <div style={{ display: "flex", justifyContent: "flex-end", width: "100%" }}>
                        <StyledTextField
                            id="basic-button"
                            fullWidth
                            aria-controls={periodMenuOpened ? "basic-menu" : undefined}
                            aria-haspopup="true"
                            aria-expanded={periodMenuOpened ? "true" : undefined}
                            onClick={handlePeriodClick}
                            size="small"
                            variant="outlined"
                            aria-readonly
                            label="Opcije perioda prikaza zadataka"
                            value={period ? (period.PeriodID != 7 ? (period.Naziv || "") : (period.Naziv + ' (' + calendarPeriodOption.Naziv + ')')) : ""}
                            style={{ cursor: "pointer" }}
                            InputProps={{
                                endAdornment: (
                                    <InputAdornment style={{ cursor: "pointer" }} position="end">
                                        {periodMenuOpened ? <KeyboardArrowUpIcon></KeyboardArrowUpIcon> : <KeyboardArrowDownIcon></KeyboardArrowDownIcon>}
                                    </InputAdornment>
                                ),
                            }}
                        ></StyledTextField>
                        <Menu
                            id="basic-menu"
                            anchorEl={anchorEl}
                            open={periodMenuOpened}
                            MenuListProps={{
                                "aria-labelledby": "basic-button",
                            }}
                            onClose={() => {
                                setAnchorEl(null);
                                setPeriod(periodHistory);
                            }}
                        >
                            <MenuItem
                                style={{ cursor: "pointer" }}
                                onClick={() => {
                                    setPeriod(periodOptions[0]);
                                }}
                            >
                                <Radio checked={period.PeriodID == 1}></Radio>
                                <ListItemText>{periodOptions[0].Naziv}</ListItemText>
                            </MenuItem>
                            <MenuItem
                                style={{ cursor: "pointer" }}
                                onClick={() => {
                                    setPeriod(periodOptions[1]);
                                }}
                            >
                                <Radio checked={period.PeriodID == 2}></Radio>
                                <ListItemText>{periodOptions[1].Naziv}</ListItemText>
                            </MenuItem>
                            <MenuItem
                                style={{ cursor: "pointer" }}
                                onClick={() => {
                                    setPeriod(periodOptions[2]);
                                }}
                            >
                                <Radio checked={period.PeriodID == 3}></Radio>
                                <ListItemText>{periodOptions[2].Naziv}</ListItemText>
                            </MenuItem>
                            <MenuItem
                                style={{ cursor: "pointer" }}
                                onClick={() => {
                                    setPeriod(periodOptions[3]);
                                }}
                            >
                                <Radio checked={period.PeriodID == 4}></Radio>
                                <ListItemText>{periodOptions[3].Naziv}</ListItemText>
                            </MenuItem>
                            <MenuItem
                                style={{ cursor: "pointer" }}
                                onClick={() => {
                                    setPeriod(periodOptions[4]);
                                }}
                            >
                                <Radio checked={period.PeriodID == 5}></Radio>
                                <ListItemText>{periodOptions[4].Naziv}</ListItemText>
                            </MenuItem>
                            <MenuItem
                                style={{ cursor: "pointer" }}
                                onClick={() => {
                                    setPeriod(periodOptions[5]);
                                }}
                            >
                                <Radio checked={period.PeriodID == 6}></Radio>
                                <ListItemText>{periodOptions[5].Naziv}</ListItemText>
                            </MenuItem>

                            <MenuItem
                                style={{ cursor: "pointer" }}
                                onClick={() => {
                                    setPeriod(periodOptions[6]);
                                }}
                            >
                                <Radio checked={period.PeriodID == 7}></Radio>
                                <ListItemText>{periodOptions[6].Naziv}</ListItemText>
                            </MenuItem>


                            {period.PeriodID == 7 ? (
                                <div>

                                <FormControl fullWidth>
                                    <MenuItem><Autocomplete style={{width:"100%"}}
                                        PaperComponent={CustomPaper}
                                        disablePortal
                                        options={calendarPeriodOptions}
                                        getOptionLabel={(option) => option.Naziv}
                                        value={calendarPeriodOption}
                                        onChange={(e,v) => {if (v) setCalendarPeriodOption(v)}}
                                        renderInput={(params) => <TextField {...params} label="Vremensko razdoblje"  size="small"/>}                    
                                    /></MenuItem>
                                </FormControl> 
                                {calendarPeriodOption.Vrijednost == 2 ? (
                                    <MenuItem>
                                        <LocalizationProvider dateAdapter={AdapterDateFns} locale={hr} utils={DateFnsUtils} fullWidth>
                                            <DatePicker
                                                views={['year']}
                                                label="Godina"
                                                value={godina}
                                                inputFormat="yyyy"
                                                onChange={(v) => {setGodina(v); setDatumOd1(v);}}
                                                renderInput={(params) => <TextField style={{width:"99%"}} {...params} onKeyDown={e => e.stopPropagation()} size="small" />}
                                            />
                                        </LocalizationProvider>
                                    </MenuItem>
                                ) : null}
                                {calendarPeriodOption.Vrijednost == 3 ? (
                                    <MenuItem>
                                        <LocalizationProvider dateAdapter={AdapterDateFns} locale={hr} utils={DateFnsUtils} fullWidth>
                                            <DatePicker
                                                views={['year', 'month']}
                                                label="Mjesec"
                                                value={mjesec}
                                                inputFormat="MM.yyyy"
                                                onChange={(v) => {setMjesec(v); setDatumOd1(v);}}
                                                renderInput={(params) => <TextField style={{width:"99%"}} {...params} onKeyDown={e => e.stopPropagation()} size="small" />}
                                            />
                                        </LocalizationProvider>
                                    </MenuItem>
                                ) : null}
                                {calendarPeriodOption.Vrijednost == 4 ? (
                                    <MenuItem>
                                        <LocalizationProvider dateAdapter={AdapterDateFns} locale={hr} utils={DateFnsUtils} fullWidth>
                                            <DatePicker
                                                label="Datum"
                                                value={datumOd1}
                                                inputFormat="dd.MM.yyyy"
                                                onChange={(v) => setDatumOd1(v)}
                                                renderInput={(params) => <TextField style={{width:"99%"}} {...params} onKeyDown={e => e.stopPropagation()} size="small" />}
                                            />
                                        </LocalizationProvider>
                                    </MenuItem>
                                ) : null}
                                {calendarPeriodOption.Vrijednost == 5 ? (
                                    <MenuItem>
                                        <LocalizationProvider dateAdapter={AdapterDateFns} locale={hr} utils={DateFnsUtils} fullWidth>
                                            <DatePicker
                                                label="Od"
                                                value={datumOd1}
                                                inputFormat="dd.MM.yyyy"
                                                onChange={handleDatumOdChange}
                                                renderInput={(params) => <TextField style={{width:"99%"}} {...params} onKeyDown={e => e.stopPropagation()} size="small" />}
                                            />
                                        </LocalizationProvider>
                                    </MenuItem>
                                ) : null}
                                {calendarPeriodOption.Vrijednost == 5 ? (
                                    <MenuItem>
                                        <LocalizationProvider dateAdapter={AdapterDateFns} locale={hr} utils={DateFnsUtils} fullWidth>
                                            <DatePicker
                                                label="Do"
                                                value={datumDo}
                                                inputFormat="dd.MM.yyyy"
                                                onChange={handleDatumDoChange}
                                                renderInput={(params) => <TextField style={{width:"99%"}} {...params} onKeyDown={e => e.stopPropagation()} size="small" />}
                                            />
                                        </LocalizationProvider>
                                    </MenuItem>
                                ) : null}


                                </div>
                            ) : null}
                            
                            
                            <Divider />
                            <div style={{ textAlign: "center", marginLeft:"10px", marginRight:"10px" }}>
                                <Button
                                    color="error"
                                    onClick={() => {
                                        setAnchorEl(null);
                                        setPeriod(periodHistory);
                                    }}
                                    style={{ marginRight: "10px" }}
                                >
                                    Zatvori
                                </Button>
                                <Button variant="outlined" onClick={handlePrimijeniClick}>
                                    <CheckIcon style={{ marginRight: "5px" }} />
                                    Primijeni
                                </Button>
                            </div>
                        </Menu>
                    </div>
                </Grid>
                <Grid item xs={6} sm={6} md={3}>
                    <FormControl fullWidth>
                        <Autocomplete
                            disablePortal
                            disableClearable
                            options={prioriteti}
                            getOptionLabel={(option) => option.Naziv}
                            value={prioritet}
                            onChange={(e,v) => {
                                setPrioritet(v);
                                filter({
                                    KorisnikID: global.drugiZaposlenik ? global.drugiZaposlenik.KorisnikID : global.user.korisnikID,
                                    TipZadatakStatusID: status.TipZadatakStatusID,
                                    TipZadatakPrioritetID: v.TipZadatakPrioritetID,
                                    KlijentID: klijent.KlijentID,
                                    PredmetID: predmet.PredmetID,
                                    Period: {
                                        ...period,
                                        DatumOd: datumOd,
                                        DatumDo: datumDo,
                                        Datum: datum,
                                        TipPregleda: period.PeriodID == 7 ? 2 : 1,
                                        TipPregledaKalendara: calendarPeriodOption.Vrijednost
                                    }
                                });
                            }}                           
                            renderInput={(params) => <TextField {...params} label="Prioritet"  size="small"/>}
                        />
                    </FormControl>
                </Grid>
                <Grid item xs={6} sm={6} md={3}>
                    <FormControl fullWidth>
                        <Autocomplete
                            disablePortal
                            disableClearable
                            options={statusi}
                            getOptionLabel={(option) => option.Naziv}
                            value={status}
                            onChange={(e,v) => {
                                setStatus(v);
                                filter({
                                    KorisnikID: global.drugiZaposlenik ? global.drugiZaposlenik.KorisnikID : global.user.korisnikID,
                                    TipZadatakStatusID: v.TipZadatakStatusID,
                                    TipZadatakPrioritetID: prioritet.TipZadatakPrioritetID,
                                    KlijentID: klijent.KlijentID,
                                    PredmetID: predmet.PredmetID,
                                    Period: {
                                        ...period,
                                        DatumOd: datumOd,
                                        DatumDo: datumDo,
                                        Datum: datum,
                                        TipPregleda: period.PeriodID == 7 ? 2 : 1,
                                        TipPregledaKalendara: calendarPeriodOption.Vrijednost
                                    }
                                });
                            }}                           
                            renderInput={(params) => <TextField {...params} label="Status"  size="small"/>}
                        />
                    </FormControl>
                </Grid>
                <Grid item xs={6}>
                    <FormControl fullWidth>
                        <Autocomplete 
                            disablePortal
                            autoHighlight
                            disableClearable
                            options={[{KlijentID: 0, Naziv:"Svi"}, ...klijentiPredmeti.Klijenti]}
                            getOptionLabel={(option) => (option.KlijentID > 0 ? option.Broj + " - " : "") + option.Naziv}
                            value={klijent}
                            onChange={handleKlijentChange}
                            renderOption={(props, option) => {
                                    return (
                                      <li {...props} key={"klijent" + option.KlijentID} style={{color: option.TipStatusaKlijentaID == 1 || option.KlijentID == 0 ? "black" : "red"}}>
                                        {(option.KlijentID > 0 ? option.Broj + " - " : "") + option.Naziv}
                                      </li>
                                    );
                                }}                            
                            filterOptions={(options, state) => options.filter(option => (option.Broj + " - " + option.Naziv).toLowerCase().includes(state.inputValue.toLowerCase()))}
                            renderInput={(params) => <TextField {...params} sx={{input:{color: klijent && klijent.TipStatusaKlijentaID != 1 && klijent.KlijentID != 0 ? "red" : "black"}}} label="Klijent"  size="small"/>}
                        />
                    </FormControl>
                </Grid>
                <Grid item xs={6}>
                    <FormControl fullWidth>
                        <Autocomplete 
                            disablePortal
                            autoHighlight
                            disableClearable
                            options={klijent && klijent.KlijentID > 0 ? [{PredmetID: 0, Naziv:"Svi"}, ...klijentiPredmeti.Predmeti.filter(p => p.KlijentID == klijent.KlijentID)] : [{PredmetID: 0, Naziv:"Svi"}]}
                            getOptionLabel={(option) => (option.PredmetID > 0 ? option.Broj + " - " : "") + option.Naziv}
                            value={predmet}
                            onChange={handlePredmetChange}
                            disabled={!klijent || klijent.KlijentID <= 0}
                            renderOption={(props, option) => {
                                    return (
                                      <li {...props} key={"predmet" + option.PredmetID} style={{color: option.TipStanjaPredmetaID != 1 && option.PredmetID != 0 ? "red" : "black"}}>
                                        {(option.PredmetID > 0 ? option.Broj + " - " : "") + option.Naziv}
                                      </li>
                                    );
                                }}                            
                            filterOptions={(options, state) => options.filter(option => (option.Broj + " - " + option.Naziv).toLowerCase().includes(state.inputValue.toLowerCase()))}
                            renderInput={(params) => <TextField {...params} sx={{input:{color: predmet && predmet.TipStanjaPredmetaID != 1 && predmet.PredmetID != 0 ? "red" : "black"}}} label="Predmet"  size="small"/>}
                        />
                    </FormControl>
                </Grid>
                <Grid item xs={12} style={{ textAlign: "center" }}>
                    {periodLabel}
                </Grid>
                <Grid item xs={12}>
                    <Divider></Divider>
                </Grid>
                {global.drugiZaposlenik && (global.drugiZaposlenik.Prava.includes(23) || global.drugiZaposlenik.Prava.includes(24)) ? (
                    <>
                        {uloge.length > 0 ? (
                            <Grid item xs={12}>
                                <Tabs value={uloga} variant="fullWidth" style={{width:"100%", marginBottom:"15px"}} centered onChange={(e,v) => {
                                    setCurrentZadatak(null);
                                    setUloga(v);
                                    if (v == 0) {
                                        if (lastCurrent.current != null && zadaci.filter(z => z.KorisniciIDs.includes(parseInt(global.drugiZaposlenik ? global.drugiZaposlenik.KorisnikID : global.user.korisnikID))).find(z => z.ZadatakID == lastCurrent.current)) {
                                            setCurrentZadatak(zadaci.find(z => z.ZadatakID == lastCurrent.current));
                                        } else if (zadaci.filter(z => z.KorisniciIDs.includes(parseInt(global.drugiZaposlenik ? global.drugiZaposlenik.KorisnikID : global.user.korisnikID))).length > 0) {
                                            setCurrentZadatak(zadaci.filter(z => z.KorisniciIDs.includes(parseInt(global.drugiZaposlenik ? global.drugiZaposlenik.KorisnikID : global.user.korisnikID)))[0]);
                                        }
                                    } else {
                                        if (lastCurrent.current != null && zadaci.filter(z => z.ZadavateljKorisnikID == (global.drugiZaposlenik ? global.drugiZaposlenik.KorisnikID : global.user.korisnikID)).find(z => z.ZadatakID == lastCurrent.current)) {
                                            setCurrentZadatak(zadaci.find(z => z.ZadatakID == lastCurrent.current));
                                        } else if (zadaci.filter(z => z.ZadavateljKorisnikID == (global.drugiZaposlenik ? global.drugiZaposlenik.KorisnikID : global.user.korisnikID)).length > 0) {
                                            setCurrentZadatak(zadaci.filter(z => z.ZadavateljKorisnikID == (global.drugiZaposlenik ? global.drugiZaposlenik.KorisnikID : global.user.korisnikID))[0]);
                                        }
                                    }
                                }}>
                                    {(global.drugiZaposlenik && global.drugiZaposlenik.Prava.includes(24) ? uloge : uloge.filter(u => u.Vrijednost == 0)).map((u,i) => {
                                        return (
                                            <Tab value={u.Vrijednost} style={{width:"100%"}} key={i} label={u.Naziv + (global.drugiZaposlenik ? (global.drugiZaposlenik.Ime + " " + global.drugiZaposlenik.Prezime) : (global.user.firstName + " " + global.lastName))}></Tab>
                                        );
                                    })}
                                </Tabs>
                            </Grid>
                        ) : null}        
                        <Grid item xs={12}>
                            <AddEditDelForm dataType="zadaci" disableEdit={!currentZadatak} disableDeleteButton={!currentZadatak || currentZadatak.ZadavateljKorisnikID != (global.drugiZaposlenik ? global.drugiZaposlenik.KorisnikID : global.user.korisnikID)} noRowsMessage={"Ne postoji niti jedan zadatak."} omoguciZadatakEvidencija={uloga == 0 && (global.drugiZaposlenik ? global.drugiZaposlenik.Prava.includes(2) : global.roles.includes("2"))} disableZadatakEvidencija={isNaN(new Date(datum)) || new Date(datum.getFullYear(), datum.getMonth(), datum.getDate()) > new Date()} zadatakEvidencija={evidencija} zadatakEvidencijaIcon={<AssignmentTurnedInIcon></AssignmentTurnedInIcon>}  data={uloga == 0 ? zadaci.filter(z => z.KorisniciIDs.includes(parseInt(global.drugiZaposlenik ? global.drugiZaposlenik.KorisnikID : global.user.korisnikID))) : zadaci.filter(z => z.ZadavateljKorisnikID == (global.drugiZaposlenik ? global.drugiZaposlenik.KorisnikID : global.user.korisnikID))} current={currentZadatak} setCurrent={setCurrentZadatak} add={add} edit={edit} del={() => setDeleteAlert(true)} ponisti={() => setPonistiAlert(true)} ponistiIcon={<HighlightOffIcon></HighlightOffIcon>}></AddEditDelForm>                    
                        </Grid>
                        {currentZadatak && currentZadatak.Evidencije && currentZadatak.Evidencije.length > 0 ? (
                            <Grid item xs={12}>
                                <Box style={{ width: "100%", marginTop: "10px" }}>
                                    <ListItem className="list-title" key={"listHeader"} style={{ backgroundColor: "lightblue" }}>
                                        <Grid container>
                                            <Grid item xs={3}>
                                                <ListItemText style={{ paddingLeft: "15px" }} primaryTypographyProps={{ noWrap: true }} primary={"Korisnik"}></ListItemText>
                                            </Grid>
                                            <Grid item xs={3}>
                                                <ListItemText style={{ paddingLeft: "15px" }} primaryTypographyProps={{ noWrap: true }} primary={"Datum"}></ListItemText>
                                            </Grid>
                                            <Grid item xs={6}>
                                                <ListItemText style={{ paddingLeft: "15px" }} primaryTypographyProps={{ noWrap: true }} primary={"Opis"}></ListItemText>
                                            </Grid>
                                        </Grid>
                                    </ListItem>
                                    <Paper variant="outlined" style={{ width: "100%", maxHeight: 100, overflow: "auto" }}>
                                        <List dense>
                                            {currentZadatak.Evidencije.map((e, index) => {
                                                return (
                                                    <ListItem className="list-item" style={{ paddingTop: 0, paddingBottom: 0 }} key={"listItem" + index}>
                                                        <Grid container>
                                                            <Grid item xs={3}>
                                                                <ListItemText style={{ paddingLeft: "15px" }} primaryTypographyProps={{ noWrap: true }} primary={e.Korisnik}></ListItemText>
                                                            </Grid>
                                                            <Grid item xs={3}>
                                                                <ListItemText style={{ paddingLeft: "15px" }} primaryTypographyProps={{ noWrap: true }} primary={e.Datum}></ListItemText>
                                                            </Grid>
                                                            <Grid item xs={6}>
                                                                <ListItemText style={{ paddingLeft: "15px" }} primaryTypographyProps={{ noWrap: true }} primary={e.Opis}></ListItemText>
                                                            </Grid>
                                                            {index != currentZadatak.Evidencije.length - 1 ? (
                                                                <Grid item xs={12}>
                                                                    <Divider></Divider>
                                                                </Grid>
                                                            ) : null}
                                                        </Grid>
                                                    </ListItem>
                                                );
                                            })}
                                        </List>
                                    </Paper>
                                </Box>
                            </Grid>
                        ) : null} 
                    </>
                ) : (
                    <Grid item xs={12}>
                        <Typography variant="button" gutterBottom component="div" style={{marginTop:"20px", display:"flex", justifyContent:"center", alignItems:"center"}}>
                            Odabrani korisnik {global.drugiZaposlenik ? ("(" + global.drugiZaposlenik.Ime + " " + global.drugiZaposlenik.Prezime + ")") : ""} nema pravo sudjelovanja u zadacima.
                        </Typography>
                    </Grid>
                )}
            </Grid>
            
            <Modal className="modal" open={formOpened}>
                <Box overflow="auto" sx={{...style, minWidth:{xs:"100%", sm:"100%", md:"70%"}}}>
                    <ZadatakForm formZadatak={zadatakForEdit} filter={() => {                        
                        lastCurrent.current = currentZadatak ? currentZadatak.ZadatakID : null;
                        filter();
                    }} uloga={uloga} klijenti={klijentiPredmeti.Klijenti} predmeti={klijentiPredmeti.Predmeti} reviewOnly={zadatakForEdit && (zadatakForEdit.TipZadatakStatusID == 4 || zadatakForEdit.TipZadatakStatusID == 3)} close={() => setFormOpened(false)}></ZadatakForm>
                </Box>
            </Modal>

            {zadatakEvidencijaInfo != null && currentZadatak ? (
                <Modal className="modal" open={evidencijaOpened}>
                    <Box sx={{...style, minWidth:{xs:"100%", sm:"100%", md:"70%"}}} overflow="auto">
                        <EvidencijaForm minsButtons={zadatakEvidencijaInfo.MinsButtons} evidencijaUPrenesenoRazdobljeMessage={zadatakEvidencijaInfo.EvidencijaUPrenesenoRazdobljeMessage} brojRedovaPredlozaka={zadatakEvidencijaInfo.BrojRedovaPredlozaka} tipZadatakVrstaID={zadatakEvidencijaInfo.TipZadatakVrstaID} zadatakPocetak={zadatakEvidencijaInfo.ZadatakPocetak} date={datum} zadatakKraj={zadatakEvidencijaInfo.ZadatakKraj} zadatakZaEvidencijuID={currentZadatak.ZadatakID} zadatakPredmeti={zadatakEvidencijaInfo.ZadatakPredmeti} zadatakOpis={currentZadatak.Opis} povezaniZadaci={zadatakEvidencijaInfo.PovezaniZadaci} loadEvidencije={() =>{ setEvidencijaOpened(false); lastCurrent.current = currentZadatak.ZadatakID; filter(null);}} omoguciPohrani={zadatakEvidencijaInfo.OmoguciPohrani} onDateChange={() => {}} predmeti={klijentiPredmeti.Predmeti} nepredmetneKategorije={zadatakEvidencijaInfo.NepredmetneKategorije} korisnikID={global.user.korisnikID} setCanceled={() => {}} setFormOpened={setEvidencijaOpened} tipoviEvidencije={zadatakEvidencijaInfo.TipoviEvidencije} klijenti={klijentiPredmeti.Klijenti} kontakti={zadatakEvidencijaInfo.Kontakti} predlosci={zadatakEvidencijaInfo.Predlosci} aktivnostDefTrajanjeMin={zadatakEvidencijaInfo.AktivnostDefTrajanjeMin} tipoviOporezivosti={zadatakEvidencijaInfo.TipoviOporezivosti} tipoviNaplatnosti={zadatakEvidencijaInfo.TipoviNaplatnosti} firmaValute={zadatakEvidencijaInfo.FirmaValute} defaultFirmaValuta={zadatakEvidencijaInfo.DefaultFirmaValuta} defaultTrosakTipOporezivosti={zadatakEvidencijaInfo.DefaultTrosakTipOporezivosti} tipEvidencijeID={1} tipNaplatnostiNaplatnoBoja={zadatakEvidencijaInfo.TipNaplatnostiNaplatnoBoja} tipNaplatnostiNenaplatnoBoja={zadatakEvidencijaInfo.TipNaplatnostiNenaplatnoBoja} defaultTarifnaAktivnostOmoguciIznosNula={zadatakEvidencijaInfo.DefaultTarifnaAktivnostOmoguciIznosNula} mogucePrebacitiAktivnostiBezCijene={zadatakEvidencijaInfo.MogucePrebacitiAktivnostiBezCijene} samoOtvoreniPredmeti={zadatakEvidencijaInfo.DefaultSamoOtvoreniPredmeti} setSamoOtvoreniPredmeti={saveSamoOtvoreniPredmeti} samoAktivniKlijenti={zadatakEvidencijaInfo.DefaultSamoAktivniKlijenti} setSamoAktivniKlijenti={saveSamoAktivniKlijenti}></EvidencijaForm>
                    </Box>
                </Modal>
            ) : null}

            {ponistiAlert ? <AlertDialog 
                                title="Poništavanje zadataka"
                                message={"Jeste li sigurni da želite poništiti odabrani zadatak? Ukoliko postoje evidencije povezane s odabranim zadatkom, njihove veze će se obrisati."} 
                                cancelLabel={"Odustani"} 
                                confirmLabel={"Poništi"} 
                                cancelAction={() => setPonistiAlert(false)} 
                                confirmAction={ponisti}>
                            </AlertDialog> : null}

            {deleteAlert ? <AlertDialog 
                title="Brisanje zadataka"
                message={"Jeste li sigurni da želite obrisati odabrani zadatak? Ukoliko postoje evidencije povezane s odabranim zadatkom, njihove veze će se obrisati."} 
                cancelLabel={"Odustani"} 
                confirmLabel={"Briši"} 
                cancelAction={() => setDeleteAlert(false)} 
                confirmAction={del}>
            </AlertDialog> : null}

            {errorMessage != null && errorMessage != "" ? <AlertDialog title="Greška" icon={<ErrorIcon style={{marginRight:"15px", color:"red"}}></ErrorIcon>} message={errorMessage} cancelHidden={false} confirmHidden={true} okHidden={true} cancelLabel={"Zatvori"} cancelAction={() => setErrorMessage("")}></AlertDialog> : null}
        
            {logoutAlert ? <AlertDialog title="Odjava" message={"Upravo se događa odjava inicirana od strane administratora."} cancelHidden={true} confirmHidden={true} okHidden={false} okLabel={"OK"} okAction={startLogout}></AlertDialog> : null}

        </ComponentContainer>
    );
}